module.exports = __webpack_public_path__ + "static/cortex-value-leader-min-ddd33f2a7c15418ca5713030a18b00a5.png";